export const PRODUCT_LIST_PAGE = 21;
export const DEFAULT_ORDER_BY_VALUE = "name";